import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.952 7.088A4.09 4.09 0 0 1 6.041 3h11.918a4.09 4.09 0 0 1 4.089 4.088v2.34a1 1 0 1 1-2 0v-2.34A2.09 2.09 0 0 0 17.959 5H6.041a2.09 2.09 0 0 0-2.089 2.088v2.34a1 1 0 1 1-2 0zm1 4.96a1 1 0 0 1 1 1V19a.6.6 0 0 0 1.035.414l2.898-3.043a3.47 3.47 0 0 1 2.513-1.077h7.561a2.09 2.09 0 0 0 2.089-2.088v-.158a1 1 0 1 1 2 0v.158a4.09 4.09 0 0 1-4.089 4.088h-7.561a1.47 1.47 0 0 0-1.065.456l-2.898 3.043c-1.618 1.7-4.483.554-4.483-1.793v-5.952a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v = { render: r };
export {
  v as default,
  r as render
};
//# sourceMappingURL=ic_comment-C-NnYsYk.js.map
